// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"180":"9a0844ef","248":"05436f5a","1766":"f2a23901","2609":"79c9770f","3236":"c1f35c5e","5008":"f2a23901","7133":"28c96362","8688":"1d5b88f4"}[chunkId] + ".chunk.css";
};